import { Controller } from 'stimulus'
import Sortable from 'sortablejs'
import Rails from '@rails/ujs'

export default class extends Controller {
static targets = ["saveListBtn"]



	connect () {

		console.log("sortable shop categories")

		this.sortable = Sortable.create(this.element, {
      animation: 100,
      group: "categories",
      ghostClass: "bg-indigo-200",
			draggable: ".draggable-category",
			onMove: function(evt) {

			},
			onEnd: function(evt) {
	
				console.log("onEnd triggered")
        

        var categoriesList = document.getElementById("product_categories_list"); 
        var parentCategories = Array.from(categoriesList.querySelectorAll('.parent-category'))
        
        var categoriesPositions = parentCategories.map(el => (
          {
            categoryId: Number(el.dataset.categoryId),
            position: Number(el.dataset.position),
            subcategories: Array.from(el.querySelectorAll('.subcategory')).map((subEl) => 
             Number(subEl.dataset.categoryId)
            ),
          }
        ))

        console.log("positions", categoriesPositions)
        
        fetch('/shop/product_categories/update_all_positions', {
          method: 'PUT',
          credentials: 'same-origin',
          headers: {
            'Accept': 'text/vnd.turbo-stream.html',
            'Content-Type': 'application/json',
            'X-CSRF-Token': Rails.csrfToken(),
          },
            body: JSON.stringify({"categories_positions": categoriesPositions})
          }).then(response => {
            if (response.ok) {
              // document.querySelector("#loading_spinner").classList.add("hidden");
              // console.log("position: updated")
            }
          })


			}
		})
	}


	disconnect () {
	}

}
